module.exports = __webpack_public_path__ + "static/img/6.5a8e416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/6.jpg
// module id = UvsH
// module chunks = 1